import { ReactNode, useEffect } from 'react';

import { useForceUpdate } from '@libs/hooks/useForceUpdate';

import { AnimatedNode } from '@ui/components/Animation';
import { useErrorNotification } from './useErrorNotification';

import styles from './ErrorsNotificationInHeader.module.css';

const MAX_DISPLAY_TIME = 5 * 1000;

export function ErrorsNotificationInHeader({ message }: { message?: ReactNode }) {
  const { timestamp, reset, error } = useErrorNotification();
  const update = useForceUpdate();

  useEffect(() => {
    if (!timestamp) return;

    const to = setTimeout(update, MAX_DISPLAY_TIME);

    return () => clearTimeout(to);
  }, [timestamp, update]);

  return (
    <AnimatedNode animation="half-opacity" className={styles.errors}>
      {timestamp && Date.now() - timestamp <= MAX_DISPLAY_TIME && (
        <div className={styles.message} key={timestamp}>
          {message ?? (
            <>
              <b>Ошибка</b>. {mapError(error)}
            </>
          )}
          <button className={styles.close} onClick={reset} aria-label="Закрыть"></button>
        </div>
      )}
    </AnimatedNode>
  );
}

function mapError(e: Error | null) {
  if (e) {
    if (e.message?.includes('Too many participants!')) {
      return 'Слишком много участников';
    }

    if (e.message?.match(/Participant:\d+:not found/)) {
      return 'Участник не найден';
    }
  }

  return 'При выполнении запроса что-то пошло не так. Повторите попытку позже';
}
